import { formantBotAgentId } from '@cortex/types';
import { createFileRoute } from '@tanstack/react-router';

import { WatchPage } from '../agents/$agentId_/threads/$threadId';

/** Same thread watch as `/agents/agt_formant_bot/threads/:id`, with the bot chrome. */
export const Route = createFileRoute('/bot/$threadId')({
  component: BotThreadPage,
});

function BotThreadPage() {
  const { threadId } = Route.useParams();
  return <WatchPage agentId={formantBotAgentId} threadId={threadId} isBot={true} />;
}
